import React, { SVGProps } from 'react';

export const TearOutWindow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.5 11.25H17V18.25H7.5C4.32562 18.2469 1.75312 15.6744 1.75 12.5006V3H8.75V4.5H3.25V12.5C3.2525 14.8462 5.15375 16.7475 7.5 16.75H15.5V11.25ZM11.25 1.75V3.25H15.69L8.845 10.095L9.905 11.155L16.75 4.31V8.75H18.25V1.75H11.25Z"
      fill="currentColor"
    />
  </svg>
);
